// extracted by mini-css-extract-plugin
export default {"container":"uox8do","priceContainer":"NuhpVy","quantityContainer":"z7_dOh"};